import React from 'react';
export const ExclamationLine24 = () => /*#__PURE__*/React.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 6C12.4142 6 12.75 6.33579 12.75 6.75V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5V6.75C11.25 6.33579 11.5858 6 12 6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.125 16.875C13.125 17.4963 12.6213 18 12 18C11.3787 18 10.875 17.4963 10.875 16.875C10.875 16.2537 11.3787 15.75 12 15.75C12.6213 15.75 13.125 16.2537 13.125 16.875Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.9996 0.225037C5.49646 0.225037 0.224609 5.49688 0.224609 12C0.224609 18.5032 5.49646 23.775 11.9996 23.775C18.5028 23.775 23.7746 18.5032 23.7746 12C23.7746 5.49688 18.5028 0.225037 11.9996 0.225037ZM1.72461 12C1.72461 6.32531 6.32488 1.72504 11.9996 1.72504C17.6743 1.72504 22.2746 6.32531 22.2746 12C22.2746 17.6748 17.6743 22.275 11.9996 22.275C6.32488 22.275 1.72461 17.6748 1.72461 12Z"
}));